"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const theme_1 = require("./theme");
const Button = ({ children, variant = 'primary', loading = false, fullWidth, disabled, style, type, ...rest }) => {
    const base = {
        width: fullWidth ? '100%' : undefined,
        padding: theme_1.theme.spacing.inputPadding,
        color: '#fff',
        border: 'none',
        borderRadius: theme_1.theme.radii.button,
        fontSize: 16,
        fontWeight: 600,
        cursor: disabled || loading ? 'not-allowed' : 'pointer',
    };
    const variantStyle = variant === 'primary'
        ? {
            background: loading ? theme_1.theme.colors.disabled : theme_1.theme.colors.primaryGradient,
        }
        : {
            background: theme_1.theme.colors.input,
            border: `2px solid ${theme_1.theme.colors.inputBorder}`,
        };
    return ((0, jsx_runtime_1.jsx)("button", { type: type ?? 'button', disabled: disabled || loading, style: { ...base, ...variantStyle, ...style }, ...rest, children: loading ? '...' : children }));
};
exports.default = Button;
